"use client";
import React, { useState } from "react";

const items = [
  { name: "BGP", value: "bgp" },
  { name: "Ping", value: "ping" },
  { name: "TRACEROUTE", value: "traceroute" },
];

export default function Tab({ setState }) {
  const [active, setActive] = useState(items[0].value);
  return (
    <div className="w-96 flex">
      {items.map(({ name, value }, ind) => (
        <div
          onClick={() => {
            setActive(value);
            setState(value);
          }}
          key={value}
          className={`tab flex uppercase gap-2 text-sm font-medium w-full cursor-pointer justify-center items-center py-[10px] transition-colors border ${
            active === value
              ? "dark:text-dark-neutral-default dark:bg-dark-surface3 dark:border-dark-neutral-default text-neutral-default bg-surface3 border-neutral-default"
              : " dark:bg-dark-surface1 dark:text-dark-neutral-medium dark:border-dark-medium bg-surface1 text-neutral-medium border-medium"
          }
          ${
            ind === 0
              ? "rounded-s-[100px]"
              : ind === items.length - 1
              ? "rounded-e-[100px]"
              : ""
          }
          `}
        >
          <span className=" transition-transform">{name}</span>
        </div>
      ))}
    </div>
  );
}
